var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`is-block has-text-${_vm.align}`},[_c('span',{staticClass:"button is-loading",class:[_vm.size, _vm.color]})])
}
var staticRenderFns = []

export { render, staticRenderFns }